import styled from 'styled-components';

const NoModifiers: React.FC = () => {
  return (
    <StyledNoModifiers>
      <p className="text">No Modifiers</p>
    </StyledNoModifiers>
  );
};

const StyledNoModifiers = styled.div`
  border: 1px dashed ${(props) => props.theme.colors.grayscale.gray2};
  border-radius: 12px;
  padding: 16px 8px;
  margin: 12px 0;

  & .text {
    font-family: ${(props) => props.theme.fontFamily};
    font-size: ${(props) => props.theme.fontSizes[1]};
    font-weight: ${(props) => props.theme.fontWeights[3]};
    color: #a7acaf;
    text-align: center;
  }
`;

export default NoModifiers;
